import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FileSetEntryViewModel, DocumentOrganizerType } from '../shared/fs.model';
import { lfFilesetLocalize } from '../shared/utils';

@Component({
  selector: 'app-organizer-toolbar',
  templateUrl: './organizer-toolbar.component.html',
  styleUrls: ['./organizer-toolbar.component.css', '../global-styles.css']
})
export class OrganizerToolbarComponent implements OnInit {

  @Input() docTotal: number;
  @Input() types: DocumentOrganizerType[];
  @Input() selectedDocs: FileSetEntryViewModel[];
  @Input() isReadonly: boolean;
  @Input() isDisabled: boolean;
  @Input() allowDownload: boolean;
  @Input() importMode: number;

  @Output() typeChange = new EventEmitter<string>();
  @Output() onImport = new EventEmitter<string>();
  @Output() deleteFile = new EventEmitter();
  @Output() refreshFileset = new EventEmitter();
  @Output() downloadFile = new EventEmitter();

  lfFilesetLocalizeHelper = lfFilesetLocalize;
  isChangeTypeOpen: boolean;
  toType: string;
  
  constructor() {}

  numSelectedDocs(){
    var total = 0;
    for (var docs of this.selectedDocs){
      if (docs.viewModel?.isSelected){
        total += 1;
      }
    }
    return total;
  }

  private OnButtonClick(fn: ()=> void){
    if (!this.isReadonly && !this.isDisabled) {
      fn();
    }
  }

  onTypeChangeClick() {
    this.OnButtonClick(()=>{
      this.isChangeTypeOpen = !this.isChangeTypeOpen;
    });
  }

  onDeleteClick() {
    this.OnButtonClick(()=>{
      this.deleteFile.emit();
    });
  }

  onDownloadClick() {
    this.OnButtonClick(()=>{
      this.downloadFile.emit();
    });
  }

  onImportClick() {
    this.OnButtonClick(()=>{
      this.onImport.emit("_none_");
    });
  }

  onRefreshClick(){
    this.OnButtonClick(()=>{
      this.refreshFileset.emit();
    });
  }

  ngOnInit(): void {
    this.toType = "";
  }

}
